<template>
    <div class="mb-6 bg-white rounded shadow">
        <base-form @submit="$emit('submit', form)">
            <header class="flex items-center px-4 py-3 border-b sm:px-6 md:py-4">
                <h1 class="text-lg font-normal">
                    {{ contact ? 'Edit' : 'Create' }} a contact
                </h1>
            </header>

            <div class="px-4 py-3 border-b sm:px-6 md:py-6">
                <validator-alert :sid="sid" />

                <form-section>
                    <template slot="title">Basics</template>
                    <template slot="description">
                        What are the contacts basic details?
                    </template>

                    <grid-layout>
                        <grid-layout-item>
                            <form-item
                                :sid="sid"
                                :is-required="true"
                                name="name"
                            >
                                <template slot="label">Name</template>

                                <input-text
                                    v-model="form.name"
                                    :sid="sid"
                                    :disabled="is_saving"
                                    name="name"
                                />
                            </form-item>
                        </grid-layout-item>

                        <grid-layout-item class="md:w-1/2">
                            <form-item
                                :sid="sid"
                                name="email"
                            >
                                <template slot="label">Email</template>

                                <input-text
                                    v-model="form.email"
                                    :sid="sid"
                                    :disabled="is_saving"
                                    type="email"
                                    name="email"
                                />
                            </form-item>
                        </grid-layout-item>

                        <grid-layout-item class="md:w-1/2">
                            <form-item
                                :sid="sid"
                                name="telephone"
                            >
                                <template slot="label">Telephone</template>

                                <input-telephone
                                    v-model="form.telephone"
                                    :sid="sid"
                                    :disabled="is_saving"
                                    type="email"
                                    name="email"
                                />
                            </form-item>
                        </grid-layout-item>
                    </grid-layout>
                </form-section>
            </div>

            <div class="px-4 py-3 border-b sm:px-6 md:py-6">
                <form-section>
                    <template slot="title">Address</template>
                    <template slot="description">
                        What's the address of the contact?
                    </template>

                    <form-items-address
                        v-model="form.address"
                        :sid="sid"
                        :is-required="false"
                        :disabled="is_saving"
                    />
                </form-section>
            </div>

            <div class="px-4 py-3 border-b sm:px-6 md:py-6">
                <form-section>
                    <template slot="title">Company</template>
                    <template slot="description">
                        Is the contact affiliated with a company?
                    </template>

                    <grid-layout>
                        <grid-layout-item class="md:w-1/2">
                            <form-item
                                :sid="sid"
                                name="job_title"
                            >
                                <template slot="label">Job Title</template>

                                <input-text
                                    v-model="form.job_title"
                                    :sid="sid"
                                    :disabled="is_saving"
                                    name="job_title"
                                />
                            </form-item>
                        </grid-layout-item>

                        <grid-layout-item class="md:w-1/2">
                            <form-item
                                :sid="sid"
                                name="company"
                            >
                                <template slot="label">Company</template>

                                <input-text
                                    v-model="form.company"
                                    :sid="sid"
                                    :disabled="is_saving"
                                    name="company"
                                />
                            </form-item>
                        </grid-layout-item>
                    </grid-layout>
                </form-section>
            </div>

            <base-form-footer>
                <base-button
                    :is-loading="is_saving"
                    type="submit"
                    class="w-full btn-blue md:w-auto"
                >
                    {{ contact ? 'Edit' : 'Create' }} Contact
                </base-button>
            </base-form-footer>

            <slot
                name="modals"
                :reset="reset"
            />
        </base-form>
    </div>
</template>

<script>
    import _ from 'lodash'
    import FormItemsAddress from '../components/form-items-address'

    export default {
        components: {
            FormItemsAddress
        },
        props: {
            contact: {
                type: Object,
                default: null
            },
            sid: {
                type: String,
                required: true
            },
            isLoading: {
                type: Boolean,
                required: true
            },
            hasLoaded: {
                type: Boolean,
                required: true
            }
        },
        data () {
            return {
                form: {
                    name: '',
                    email: '',
                    telephone: null,
                    job_title: '',
                    company: '',
                    address: {
                        street: '',
                        locality: '',
                        village: '',
                        town: '',
                        county: '',
                        postcode: ''
                    }
                }
            }
        },
        created () {
            this.reset()
        },
        computed: {
            is_saving () {
                return this.isLoading
            }
        },
        methods: {
            reset (sid = null) {
                if (sid) {
                    this.$validator.reset(sid)
                }

                this.form.name = _.get(this.contact, 'name')
                this.form.email = _.get(this.contact, 'email')
                this.form.telephone = _.get(this.contact, 'telephone_number')
                    ? _.pick(this.contact.telephone_number, ['prefix', 'suffix'])
                    : null
                this.form.job_title = _.get(this.contact, 'job_title')
                this.form.company = _.get(this.contact, 'company')

                if (_.get(this.contact, 'address')) {
                    this.form.address.street = _.get(this.contact, 'address.street')
                    this.form.address.locality = _.get(this.contact, 'address.locality')
                    this.form.address.village = _.get(this.contact, 'address.village')
                    this.form.address.town = _.get(this.contact, 'address.town')
                    this.form.address.county = _.get(this.contact, 'address.county')
                    this.form.address.postcode = _.get(this.contact, 'address.postcode')
                }
            }
        }
    }
</script>
